const ADMIN = "/admin"
const ADMIN_SETTINGS = `${ADMIN}/settings`
const ADMIN_SETTINGS_INVOICES = `${ADMIN_SETTINGS}/invoices`
const ADMIN_SETTINGS_PRODUCTS = `${ADMIN_SETTINGS}/products`
const ADMIN_SETTINGS_COUPONS = `${ADMIN_SETTINGS}/coupons`
const ADMIN_SETTINGS_AUTOMATED_MESSAGES = `${ADMIN_SETTINGS}/automated-messages`
const ADMIN_SETTINGS_RULES_TERMS = `${ADMIN_SETTINGS}/rules-terms`

export const ROUTER_PATHS = {
  ADMIN,
  ADMIN_SETTINGS,
  ADMIN_SETTINGS_INVOICES,
  ADMIN_SETTINGS_PRODUCTS,
  ADMIN_SETTINGS_COUPONS,
  ADMIN_SETTINGS_AUTOMATED_MESSAGES,
  ADMIN_SETTINGS_RULES_TERMS,
}
